import {
  useGetTradeInStatus,
  useIsTradeInApplied
} from '~/context/common/TradeContext';
import shouldShowTradeIncentive from '~/utilities/common/shouldShowTradeIncentive';
import useGetIsInTaxSavingRestrictedState from './useGetIsInTaxSavingRestrictedState';

type OwnArgs = {
  tradeIncentive?: number;
  tradeTaxSavings?: number;
};

// there is currently a bug where if you select a pending trade-in we still show the /w trade treatment
// added isActive here to hide in this scenario but we should revisit once that bug is fixed
export default function useShowTradeIncentivesCopy({
  tradeIncentive,
  tradeTaxSavings
}: OwnArgs = {}) {
  const isTradeInApplied = useIsTradeInApplied();
  const isInTaxRestrictedState = useGetIsInTaxSavingRestrictedState();
  const { isActive: isActiveTrade } = useGetTradeInStatus();

  const shouldShowTreatment = isTradeInApplied && isActiveTrade;

  const hasTaxSavings = (tradeTaxSavings ?? 0) > 0;

  return {
    showTaxSavings:
      shouldShowTreatment && hasTaxSavings && !isInTaxRestrictedState,
    showTradeIncentive: shouldShowTradeIncentive({
      isActiveTrade,
      isTradeInApplied,
      tradeIncentive
    })
  };
}
